import { useState, useEffect } from 'react';
import { apiFetch } from './shared';

function localDate() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

const BELASTUNG_FARBE = { leicht: '#4a9c6f', mittel: '#c17f24', schwer: '#cf5050' };
const BELASTUNG_LABEL = { leicht: 'Leicht', mittel: 'Mittel', schwer: 'Schwer' };
const INPUT = { display:'block', width:'100%', background:'#111', border:'1px solid #2a2a2a', borderRadius:4, padding:'7px 8px', color:'#e0e0e0', fontSize:13, fontFamily:'inherit', outline:'none', boxSizing:'border-box', marginTop:3 };

export default function Atemschutz({ onClose }) {
  const [einheiten, setEinheiten] = useState([]);
  const [stats, setStats]         = useState(null);
  const [g26, setG26]             = useState(null);
  const [editG26, setEditG26]     = useState(false);
  const [g26Form, setG26Form]     = useState({ letzt_datum:'', intervall_monate: 12 });
  const [form, setForm]           = useState({
    datum: localDate(), dauer_min: '', belastung: 'mittel', pa_gewicht_kg: '', notiz: '',
  });
  const [saveStatus, setSaveStatus] = useState('idle');

  function reload() {
    apiFetch('/api/feuerwehr/atemschutz').then(r => r.json()).then(setEinheiten).catch(() => {});
    apiFetch('/api/feuerwehr/stats').then(r => r.json()).then(setStats).catch(() => {});
    apiFetch('/api/feuerwehr/g26').then(r => r.json()).then(d => {
      setG26(d);
      setG26Form({ letzt_datum: d.letzt_datum || '', intervall_monate: d.intervall_monate || 12 });
    }).catch(() => {});
  }

  useEffect(() => { reload(); }, []);

  function save() {
    if (!form.dauer_min) return;
    setSaveStatus('saving');
    apiFetch('/api/feuerwehr/atemschutz', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        datum: form.datum, dauer_min: parseInt(form.dauer_min),
        belastung: form.belastung,
        pa_gewicht_kg: form.pa_gewicht_kg ? parseInt(form.pa_gewicht_kg) : null,
        notiz: form.notiz || null,
      }),
    })
      .then(() => {
        setSaveStatus('saved');
        setForm(f => ({ ...f, dauer_min: '', pa_gewicht_kg: '', notiz: '' }));
        reload();
        setTimeout(() => setSaveStatus('idle'), 1500);
      })
      .catch(() => { setSaveStatus('error'); setTimeout(() => setSaveStatus('idle'), 2000); });
  }

  function del(e) {
    if (e.quelle === 'strava') {
      // Kennzeichnung entfernen
      apiFetch('/api/strava/aktivitaeten/' + e.id + '/atemschutz', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ atemschutz: false }),
      }).then(() => reload());
    } else {
      apiFetch('/api/feuerwehr/atemschutz/' + e.id, { method: 'DELETE' })
        .then(() => reload());
    }
  }

  function saveG26() {
    apiFetch('/api/feuerwehr/g26', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ letzt_datum: g26Form.letzt_datum || null, intervall_monate: parseInt(g26Form.intervall_monate) }),
    }).then(() => { setEditG26(false); reload(); });
  }

  const g26Farbe = g26?.status === 'ueberfaellig' ? '#cf5050'
                 : g26?.status === 'bald'          ? '#c17f24'
                 : g26?.status === 'ok'            ? '#4a9c6f'
                 : '#555';

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ fontSize:16, fontWeight:700, color:'#c17f24' }}>Atemschutz-Tracker</div>
        <button onClick={onClose} style={{ background:'transparent', border:'1px solid #2a2a2a', borderRadius:6, color:'#666', fontSize:12, padding:'4px 12px', cursor:'pointer', fontFamily:'inherit' }}>
          Zurück
        </button>
      </div>

      {/* G26-Status */}
      <div style={{ background:'#141414', borderRadius:8, padding:'14px 16px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
          <div>
            <div style={{ fontSize:10, color:'#555', letterSpacing:2, marginBottom:6 }}>G26.3 UNTERSUCHUNG</div>
            {g26?.letzt_datum ? (
              <>
                <div style={{ fontSize:12, color:'#888', marginBottom:3 }}>
                  Letzte: {new Date(g26.letzt_datum + 'T12:00').toLocaleDateString('de-DE', { day:'numeric', month:'long', year:'numeric' })}
                </div>
                <div style={{ fontSize:12, color:'#888', marginBottom:6 }}>
                  Nächste: {new Date(g26.naechst_datum + 'T12:00').toLocaleDateString('de-DE', { day:'numeric', month:'long', year:'numeric' })}
                  <span style={{ marginLeft:8, color: g26Farbe, fontWeight:700 }}>
                    {g26.tage_bis < 0
                      ? `${Math.abs(g26.tage_bis)}d überfällig`
                      : `noch ${g26.tage_bis}d`}
                  </span>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <div style={{ width:8, height:8, borderRadius:'50%', background: g26Farbe }} />
                  <span style={{ fontSize:11, color: g26Farbe }}>
                    {g26.status === 'ueberfaellig' ? 'Untersuchung überfällig!' : g26.status === 'bald' ? 'Termin bald fällig' : 'Atemschutzeignung gültig'}
                  </span>
                </div>
              </>
            ) : (
              <div style={{ fontSize:12, color:'#555' }}>Noch kein G26-Datum hinterlegt</div>
            )}
          </div>
          <button onClick={() => setEditG26(v => !v)}
            style={{ background:'#1a1a1a', border:'none', borderRadius:5, color:'#666', fontSize:11, padding:'5px 10px', cursor:'pointer', fontFamily:'inherit' }}>
            {editG26 ? '▲' : 'Bearbeiten'}
          </button>
        </div>

        {editG26 && (
          <div style={{ marginTop:12, borderTop:'1px solid #1e1e1e', paddingTop:12, display:'flex', flexDirection:'column', gap:8 }}>
            <label style={{ fontSize:10, color:'#555' }}>
              Datum letzte Untersuchung
              <input type="date" value={g26Form.letzt_datum} onChange={e => setG26Form(f => ({...f, letzt_datum: e.target.value}))} style={INPUT} />
            </label>
            <label style={{ fontSize:10, color:'#555' }}>
              Intervall (Monate)
              <input type="number" min="6" max="36" value={g26Form.intervall_monate} onChange={e => setG26Form(f => ({...f, intervall_monate: e.target.value}))} style={INPUT} />
            </label>
            <button onClick={saveG26}
              style={{ background:'#1a3a2a', border:'1px solid #2a5c3a', borderRadius:5, color:'#4a9c6f', fontSize:12, padding:'8px', cursor:'pointer', fontFamily:'inherit' }}>
              Speichern
            </button>
          </div>
        )}
      </div>

      {/* Statistiken */}
      {stats && (
        <div style={{ background:'#141414', borderRadius:8, padding:'12px 16px' }}>
          <div style={{ fontSize:10, color:'#555', letterSpacing:2, marginBottom:8 }}>STATISTIK</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <div>
              <div style={{ fontSize:10, color:'#555', marginBottom:2 }}>Letzte 30 Tage</div>
              <div style={{ fontSize:22, fontWeight:700, color:'#c17f24' }}>{stats.m30?.einheiten || 0}</div>
              <div style={{ fontSize:10, color:'#555' }}>Einheiten</div>
              <div style={{ fontSize:12, color:'#888', marginTop:2 }}>{stats.m30?.minuten || 0} min</div>
            </div>
            <div>
              <div style={{ fontSize:10, color:'#555', marginBottom:2 }}>Letztes Jahr</div>
              <div style={{ fontSize:22, fontWeight:700, color:'#e0e0e0' }}>{stats.m12?.einheiten || 0}</div>
              <div style={{ fontSize:10, color:'#555' }}>Einheiten</div>
              <div style={{ fontSize:12, color:'#888', marginTop:2 }}>{Math.round((stats.m12?.minuten || 0) / 60 * 10) / 10} h</div>
            </div>
            <div>
              <div style={{ fontSize:10, color:'#555', marginBottom:2 }}>Ø Dauer</div>
              <div style={{ fontSize:22, fontWeight:700, color:'#888' }}>{stats.m30?.avg_dauer || '—'}</div>
              <div style={{ fontSize:10, color:'#555' }}>min</div>
            </div>
          </div>
          {stats.verteilung?.length > 0 && (
            <div style={{ marginTop:10, display:'flex', gap:8 }}>
              {stats.verteilung.map(v => (
                <div key={v.belastung} style={{ fontSize:10, background:'#111', borderRadius:4, padding:'3px 8px', color: BELASTUNG_FARBE[v.belastung] }}>
                  {BELASTUNG_LABEL[v.belastung]}: {v.n}×
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Neue Einheit eintragen */}
      <div style={{ background:'#0a140a', border:'1px solid #2a5c2a', borderRadius:8, padding:'14px 16px' }}>
        <div style={{ fontSize:11, color:'#4a9c6f', letterSpacing:2, marginBottom:12 }}>EINHEIT EINTRAGEN</div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
          <label style={{ fontSize:10, color:'#555' }}>
            Datum
            <input type="date" value={form.datum} onChange={e => setForm(f => ({...f, datum: e.target.value}))} style={INPUT} />
          </label>
          <label style={{ fontSize:10, color:'#555' }}>
            Dauer (Minuten)*
            <input type="number" min="1" max="180" placeholder="30" value={form.dauer_min} onChange={e => setForm(f => ({...f, dauer_min: e.target.value}))} style={INPUT} />
          </label>
        </div>

        <div style={{ marginBottom:8 }}>
          <div style={{ fontSize:10, color:'#555', marginBottom:4 }}>BELASTUNG</div>
          <div style={{ display:'flex', gap:6 }}>
            {['leicht','mittel','schwer'].map(b => (
              <button key={b} onClick={() => setForm(f => ({...f, belastung: b}))}
                style={{ flex:1, background: form.belastung === b ? '#1a2a1a' : '#111', border:`1px solid ${form.belastung === b ? BELASTUNG_FARBE[b] : '#2a2a2a'}`, borderRadius:5, padding:'7px 4px', fontSize:11, fontWeight: form.belastung === b ? 700 : 400, color: form.belastung === b ? BELASTUNG_FARBE[b] : '#444', cursor:'pointer', fontFamily:'inherit' }}>
                {BELASTUNG_LABEL[b]}
              </button>
            ))}
          </div>
        </div>

        <label style={{ fontSize:10, color:'#555', display:'block', marginBottom:8 }}>
          PA-Gewicht (kg, optional)
          <input type="number" min="10" max="30" step="0.5" placeholder="z.B. 16" value={form.pa_gewicht_kg} onChange={e => setForm(f => ({...f, pa_gewicht_kg: e.target.value}))} style={INPUT} />
        </label>

        <label style={{ fontSize:10, color:'#555', display:'block', marginBottom:12 }}>
          Notiz (optional)
          <input type="text" placeholder="z.B. Übungsgebäude, Brandsimulation..." value={form.notiz} onChange={e => setForm(f => ({...f, notiz: e.target.value}))} style={INPUT} />
        </label>

        <button onClick={save} disabled={!form.dauer_min || saveStatus === 'saving'}
          style={{ background: saveStatus === 'saved' ? '#2a5c3a' : saveStatus === 'error' ? '#5c2a2a' : form.dauer_min ? '#2a5c2a' : '#1a1a1a', color: form.dauer_min ? '#fff' : '#444', border:'none', borderRadius:6, padding:'10px 20px', fontSize:13, fontWeight:700, cursor: form.dauer_min ? 'pointer' : 'default', fontFamily:'inherit' }}>
          {saveStatus === 'saved' ? '✓ Einheit gespeichert' : saveStatus === 'saving' ? 'Speichere...' : 'Einheit eintragen'}
        </button>
      </div>

      {/* Einheiten-Liste */}
      <div style={{ background:'#141414', borderRadius:8, overflow:'hidden' }}>
        <div style={{ padding:'10px 16px', background:'#1c1c1c', fontSize:11, color:'#888', letterSpacing:2, borderBottom:'1px solid #222' }}>
          LETZTE EINHEITEN
        </div>
        {einheiten.length === 0 && (
          <div style={{ padding:'14px 16px', fontSize:12, color:'#444' }}>Noch keine Einheiten eingetragen</div>
        )}
        {einheiten.map(e => {
          const istStrava = e.quelle === 'strava';
          const belastungFarbe = BELASTUNG_FARBE[e.belastung] || '#555';
          return (
            <div key={`${e.quelle}-${e.id}`} style={{ padding:'12px 16px', borderBottom:'1px solid #1c1c1c', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={{ flex:1 }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:2, flexWrap:'wrap' }}>
                  <div style={{ fontSize:13, fontWeight:600, color:'#e0e0e0' }}>{e.dauer_min} min</div>
                  {e.belastung && (
                    <div style={{ fontSize:9, color: belastungFarbe, border:`1px solid ${belastungFarbe}`, borderRadius:3, padding:'1px 5px' }}>
                      {BELASTUNG_LABEL[e.belastung]}
                    </div>
                  )}
                  {e.pa_kg && <div style={{ fontSize:9, color:'#666' }}>{e.pa_kg} kg PA</div>}
                  {istStrava && (
                    <div style={{ fontSize:9, color:'#5a8fd4', border:'1px solid #2a3a5a', borderRadius:3, padding:'1px 5px' }}>Strava</div>
                  )}
                </div>
                <div style={{ fontSize:11, color:'#555' }}>
                  {new Date(e.datum + 'T12:00').toLocaleDateString('de-DE', { weekday:'short', day:'numeric', month:'short', year:'numeric' })}
                </div>
                {e.notiz && <div style={{ fontSize:11, color:'#444', marginTop:2 }}>{e.notiz}</div>}
              </div>
              <button onClick={() => del(e)}
                style={{ background:'#2a1a1a', border:'1px solid #4a2a2a', borderRadius:5, color:'#c05050', fontSize:11, padding:'4px 8px', cursor:'pointer', fontFamily:'inherit', marginLeft:8, whiteSpace:'nowrap' }}>
                {istStrava ? 'Markierung weg' : 'Löschen'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
